import { dataUserIntersection } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserIntersection = /*#__PURE__*/createIcon(dataUserIntersection)
export default IconUserIntersection
